import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Link, Paper, Typography } from '@mui/material';
import { AutoAwesome as AutoAwesomeIcon, EditNote as EditNoteIcon } from '@mui/icons-material';
import { PlansNotice } from './shared';

interface SetUpYourselfBarProps {
  hasActiveSubscription: boolean;
  onUseAI: () => void;
}

/** Slim bar above the form when a new function is being filled in by hand. */
export const SetUpYourselfBar: React.FC<SetUpYourselfBarProps> = ({ hasActiveSubscription, onUseAI }) => {
  if (!hasActiveSubscription) {
    return (
      <Box sx={{ mb: 3 }}>
        <PlansNotice>
          Want AI to set this up for you? Creating with AI is part of a paid plan. You can still fill in the form below
          yourself.
        </PlansNotice>
      </Box>
    );
  }

  return (
    <Paper
      variant="outlined"
      sx={{ mb: 3, px: 2, py: 1.25, borderRadius: 2, display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}
    >
      <EditNoteIcon color="action" />
      <Box sx={{ flex: '1 1 320px' }}>
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          You're setting it up yourself
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Fill in the form below, then click Save. Need a custom output format?{' '}
          <Link component={RouterLink} to="/dashboard/objects/generate">
            Describe it in the Object Generator
          </Link>
          .
        </Typography>
      </Box>
      <Button size="small" variant="outlined" startIcon={<AutoAwesomeIcon />} onClick={onUseAI}>
        Describe it to AI instead
      </Button>
    </Paper>
  );
};

export default SetUpYourselfBar;
